/* eslint-disable */
/* istanbul ignore file */
import React from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import { Button } from '../../../../components/Button'
import { fetchAssetCategories, fetchGatewayType, createGateway, imageUpload, fetchTimeZones } from '../../redux/actionCreators'
import { type AssetCategoriesState } from '../../redux/assetCategoriesSliceGateway'
import { type GatewayTypeState } from '../../redux/gatewayTypeSlice'
import { connect, type ConnectedProps, useSelector, useDispatch } from 'react-redux'
import { type RootState } from '../../../../store'
import { type OperationPermissionState } from '../../../dashboard/redux/operationPermissionSlice'
import { useAuth } from 'react-oidc-context'
import { getOperationPermissions } from '../../../dashboard/redux/actionCreator'
import Link from '@mui/material/Link'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import ArrowBackIos from '@mui/icons-material/ArrowBackIos'
import Typography from '@mui/material/Typography'
import LanguageStrings from '../../../../i18n/locales'
import GatewayInformation from './GatewayInformation'
import AddGatewayDummy from '../../../../assets/AddDevice/image.png'
import { type CreateGatewayPostRequest } from '../../services/createGatewayService'
import { type CreateGatewayState } from '../../redux/createGatewaySlice'
import Modal from '../../../../components/Modal'
import { CircularProgress } from '@mui/material'
import CustomToast from '../ToastComponent'
import {isValidText, isValidGatewayData, isValidIp, isValidGatewayPort} from '../../../../utils/validator'
import { APIConfiguration } from '../../../../utils/apiConfiguration'
import { type ImageUploadState } from '../../redux/imageUploadSliceGateway'
import { type ImageUploadPostRequest } from '../../services/imageUploadService'
import { reset } from '../../redux/createGatewaySlice'
import { useLocation } from 'react-router-dom'
import { getCustomDeviceDropdownMetadata } from '../../../custom-device/redux/actionCreators'
import { type DeviceDropDownMetadataState } from '../../../custom-device/redux/getDeviceDropDownMetaDataSlice'
import { type TimezoneDataState } from '../../redux/timezoneDataSlice'
import AuthError from "../../../../components/ErrorComponents/AuthError"

const httpStatus = APIConfiguration
const MAX_LENGTH = 100
const MAX_GATEWAY_DESCRIPTION_LENGTH = 500
const AddGatewayStrings = LanguageStrings().GatewayManagementCollectionStrings.AddGatewayComponent
const DashboardStrings = LanguageStrings().Dashboard

interface LabelValue {
  label: string
  value: string
}

const AddGatewayComponent = (props: PropsFromRedux): JSX.Element => {
  const navigate = useNavigate()// istanbul ignore next
  const dispatch = useDispatch()
  const stateLocation = useLocation()
  const { parentAssetId } = useParams() as { parentAssetId: string }
  const [isGatewayDetailsEnabled, setIsGatewayDetailsEnabled] = React.useState(true)
  const operationPermissions: OperationPermissionState = useSelector(
    (state: RootState) => state.operationPermissions
  )
  const [categoryTypeId, setCategoryTypeId] = React.useState('')
  const [assetType, setAssetType] = React.useState<LabelValue | null>(null)
  const [assetModel, setAssetModel] = React.useState<LabelValue | null>(null)
  const [gatewayId, setGatewayId] = React.useState('')
  const [gatewayName, setGatewayName] = React.useState('')
  const [gatewayNameErrorInit, setGatewayNameErrorInit] = React.useState(false)
  const [gatewayDescription, setGatewayDescription] = React.useState('')
  const [gatewayDescriptionErrorInit, setGatewayDescriptionErrorInit] = React.useState(false)
  const [portNumber, setPortNumber] = React.useState('')
  const [portNumberErrorInit, setPortNumberErrorInit] = React.useState(false)
  const [applicationType, setApplicationType] = React.useState('')
  const [applicationTypeErrorInit, setApplicationTypeErrorInit] = React.useState(false)
  const [location, setLocation] = React.useState('')
  const [locationErrorInit, setLocationErrorInit] = React.useState(false)
  const [ipAddress, setIpAddress] = React.useState('')
  const [ipAddressErrorInit, setIpAddressErrorInit] = React.useState(false)
  const [previewImage, setPreviewImage] = React.useState<string | null>(AddGatewayDummy)
  const [showConfirmation, setShowConfirmation] = React.useState(false)
  const [showCreatePopup, setShowCreatePopup] = React.useState(false)
  const [isStdError, setIsStdError] = React.useState(false)
  const [isCustomError, setIsCustomError] = React.useState(false)
  const [isModbusError, setIsModbusError] = React.useState(false)
  const [gatewayImage, setGatewayImage] = React.useState<any>()
  const auth = useAuth()
  const thermalCategory = 'Thermal'
  const { parentSiteId: parentSiteId } = stateLocation.state || {};
  const [protocolOptions, setProtocolOptions] = React.useState<LabelValue[]>([])
  const [timezoneOptions, setTimezoneOptions] = React.useState<LabelValue[]>([])
  const [protocol, setProtocol] = React.useState<LabelValue | null>(null)
  const [timezone, setTimezone] = React.useState<LabelValue | null>(null)
  const [showImagePopup, setShowImagePopup] = React.useState(false)

  React.useEffect(() => {
    (parentSiteId === '' || parentSiteId === undefined || parentSiteId === null) && navigate('/site-list')
  }, [parentSiteId])

  React.useEffect(() => {
    if (!operationPermissions.updated) {
      props.getOperationPermissions(auth.user?.profile.sub as string)
    }
    props.fetchAssetCategories()
    props.getCustomDeviceDropdownMetadata()
    props.fetchTimeZones()
  }, [])
  const protocolOptionsData = useSelector((state: RootState) => state.deviceDropDownMetadata.DeviceDropDownMetadata?.protocols)
  const timezoneOptionsData = useSelector((state: RootState) => state.timezoneDropDownMetaData.TimezoneDropDownMetadata)
  
  React.useEffect(() => {
    if (protocolOptionsData !== undefined && protocolOptionsData.length > 0) {
      let protocolArray: LabelValue[] = []
      protocolArray = protocolOptionsData.map((item: any) => ({
        value: item.commTypeId,
        label: item.commType
      }))
      setProtocolOptions(protocolArray)
    }
  }, [protocolOptionsData])

  React.useEffect(() => {
    if (timezoneOptionsData !== null && timezoneOptionsData.length > 0) {
      let timezoneArray: LabelValue[] = []
      timezoneArray = timezoneOptionsData.map((item: any) => ({
        value: item.zone_id,
        label: item.zone_name
      }))
      setTimezoneOptions(timezoneArray)
    }
  }, [timezoneOptionsData])

  React.useEffect(() => {
    if (props.createGatewayState.data != null && props.createGatewayState.data.asset_id) {
      setGatewayId(props.createGatewayState.data.asset_id)
      if (gatewayImage) {
        setShowCreatePopup(false)
        setShowImagePopup(true)
        props.imageUpload({
          assetId: props.createGatewayState.data.asset_id,
          assetTypeId: assetType?.value,
          locale: 'en_US',
          file: gatewayImage
        })
      }
    }
  }, [props.createGatewayState])

  React.useEffect(() => {
    if (props.assetCategories?.assetCategories != null && props.assetCategories.assetCategories.length > 0) {
      const thermalCat = props.assetCategories.assetCategories.find(
        (cat: any) => cat.category_type_name === thermalCategory
      )
      if (thermalCat != null) {
        setCategoryTypeId(thermalCat.category_type_id)
        props.fetchGatewayType(thermalCat.category_type_id)
      }
    }
  }, [props.assetCategories])

  React.useEffect(() => {
    return () => {
      setIsGatewayDetailsEnabled(true);
      setCategoryTypeId('');
      setAssetType(null);
      setAssetModel(null);
      setGatewayId('');
      setGatewayName('');
      setGatewayNameErrorInit(false);
      setGatewayDescription('');
      setGatewayDescriptionErrorInit(false);
      setPortNumber('');
      setPortNumberErrorInit(false);
      setApplicationType('');
      setApplicationTypeErrorInit(false);
      setLocation('');
      setLocationErrorInit(false);
      setIpAddress('');
      setIpAddressErrorInit(false);
      setPreviewImage(AddGatewayDummy);
      setGatewayImage(undefined);
      dispatch(reset());
    };
  }, []);

  function handleBreadCrumbsClick(
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ): void {
    event.preventDefault()
  }

  const handeleCancelClick = (): void => {
    navigate(`/gateway-list/${parentAssetId}`, { state: { parentSiteId } });
  }
  const moveBackOneStep = (): void => {
    setIsGatewayDetailsEnabled(true)
  }

  const handleCreateGateway = (): void => {
    if (gatewayId === '') {
      createGateway()
    } else setIsGatewayDetailsEnabled(false)
  }

  const createGateway = (): void => {
    const CurrentDate = new Date().toISOString()
    const postData = {
      type: 'gateway',
      name: gatewayName,
      description: gatewayDescription,
      ip_address: ipAddress,
      install_date: CurrentDate,
      site_id: parentSiteId,
      asset_id: parentAssetId,
      asset_type_id: "fdd42da4-4a13-4f57-9e1a-208d95c7f213",
      gateway_type_id: assetType?.value,
      timezone: timezone?.value,
      communication_protocol_id: protocol?.value,
      port: protocol?.label !== 'MODBUS-TCP/IP' ? portNumber : ''
    }
    props.createGateway(postData)
  }

  /* istanbul ignore next */
  const handleCreateGatewayWithFailure = (): JSX.Element => {
    if (!props.createGatewayState.isLoading && props.createGatewayState.httpStatus === httpStatus.CREATED_HTTP_STATUS) {
      return (
        <Modal buttonTypeNegative='hollow' title={AddGatewayStrings.SuccessfullyAdded} LabelPositive={AddGatewayStrings.okay}
          onClickPositive={() => { setShowCreatePopup(false), handeleCancelClick() }}
          onClose={() => { setShowCreatePopup(false), handeleCancelClick() }}>
          <p style={{ paddingTop: '1.2em' }}>{AddGatewayStrings.GatewayHasBeenCreated}</p>
        </Modal>
      )
    } else if (props.createGatewayState.isLoading) {
      return (
        <Modal title={AddGatewayStrings.CreatingGateway}>
          <div className='CircularprogressAmi'><CircularProgress /></div>
        </Modal>
      )
    } else if (props.createGatewayState.httpStatus === httpStatus.BAD_REQUEST) {
      return (
        <Modal buttonTypeNegative="hollow" title={"Failed"} LabelPositive="Okay"
          onClickPositive={() => { setShowCreatePopup(false) }} onClose={() => { setShowCreatePopup(false) }}
        >
          <p style={{ paddingTop: "1.2em" }}> {props.createGatewayState.error ?? 'Error'} </p>
        </Modal>
      );
    } else if (props.createGatewayState.httpStatus === httpStatus.INTERNAL_SERVER_ERROR || props.createGatewayState.httpStatus === httpStatus.CONFLICT_ERROR) {
      return (
        <Modal buttonTypeNegative="hollow" title={"Failed"} LabelPositive="Okay"
          onClickPositive={() => { setShowCreatePopup(false) }} onClose={() => { setShowCreatePopup(false) }}
        >
          <p style={{ paddingTop: "1.2em" }}> {props.createGatewayState.error ?? 'Error'} </p>
        </Modal>
      );
    } else if (props.createGatewayState.httpStatus === httpStatus.UNAUTHORIZED_HTTP_STATUS) {
      return (
        <div className="authError"><AuthError errorMessage="Unauthorized" /></div>
      )
    } else {
      return (
        <Modal buttonTypeNegative="hollow" title={"Failed"} LabelPositive="Okay"
          onClickPositive={() => { setShowCreatePopup(false) }}
          onClose={() => { setShowCreatePopup(false) }}
        >
          <p style={{ paddingTop: "1.2em" }}> {AddGatewayStrings.AddGatewayError} </p>
        </Modal>
      )
    }
  }

  const handleImageWithFailure = (): JSX.Element => {
    if (props.imageUploadState.isLoading === false && props.imageUploadState.httpStatus === httpStatus.CREATED_HTTP_STATUS) {
      return (
        <Modal buttonTypeNegative='hollow' title={AddGatewayStrings.SuccessfullyAdded} LabelPositive={AddGatewayStrings.okay}
          onClickPositive={() => { setShowImagePopup(false), handeleCancelClick() }}
          onClose={() => { setShowImagePopup(false), handeleCancelClick() }}>
          <p style={{ paddingTop: '1.2em' }}>{AddGatewayStrings.GatewayHasBeenCreated}</p>
        </Modal>
      )
    } else if (props.imageUploadState.isLoading) {
      return (
        <Modal title={AddGatewayStrings.CreatingGateway}>
          <div className='CircularprogressAmi'><CircularProgress /></div>
        </Modal>
      )
    } else if (props.imageUploadState.httpStatus === httpStatus.BAD_REQUEST) {
      return (
        <Modal buttonTypeNegative="hollow" title={"Failed"} LabelPositive="Okay"
          onClickPositive={() => { setShowImagePopup(false) }} onClose={() => { setShowImagePopup(false) }}
        >
          <p style={{ paddingTop: "1.2em" }}> {props.imageUploadState.error ?? 'Error'} </p>
        </Modal>
      );
    } else if (props.imageUploadState.httpStatus === httpStatus.INTERNAL_SERVER_ERROR || props.imageUploadState.httpStatus === httpStatus.CONFLICT_ERROR) {
      return (
        <Modal buttonTypeNegative="hollow" title={"Failed"} LabelPositive="Okay"
          onClickPositive={() => { setShowImagePopup(false) }} onClose={() => { setShowImagePopup(false) }}
        >
          <p style={{ paddingTop: "1.2em" }}> {props.imageUploadState.error ?? 'Error'} </p>
        </Modal>
      );
    } else if (props.imageUploadState.httpStatus === httpStatus.UNAUTHORIZED_HTTP_STATUS) {
      return (
        <div className="authError"><AuthError errorMessage="Unauthorized" /></div>
      )
    } else {
      return (
        <Modal buttonTypeNegative="hollow" title={"Failed"} LabelPositive="Okay"
          onClickPositive={() => { setShowImagePopup(false) }}
          onClose={() => { setShowImagePopup(false) }}
        >
          <p style={{ paddingTop: "1.2em" }}>{AddGatewayStrings.AddGatewayError}</p>
        </Modal>
      )
    }
  }

  const handleFetchCategoryWithFailure = (): JSX.Element | null => {
    /* istanbul ignore next */
    if (props.assetCategories.isLoading === false && props.assetCategories.httpStatus === 200) {
      return null
    } else if (props.assetCategories.isLoading === false && props.assetCategories?.loadingError !== '') {
      CustomToast({
        type: 'error',
        heading: AddGatewayStrings.Error,
        message: AddGatewayStrings.FetchAssetTypeError
      })
      return null
    }
    return null
  }

  const isGatewayNameNotValid = (): boolean => {
    return (
      !isValidGatewayData(gatewayName) || gatewayName.length > MAX_LENGTH
    )
  }
  const isGatewayDescriptionNotValid = (): boolean => {
    return (
      !isValidGatewayData(gatewayDescription) || gatewayDescription.length > MAX_GATEWAY_DESCRIPTION_LENGTH
    )
  }
  const isPortNumberNotValid = (): boolean => {
    const port = parseInt(portNumber, 10)
    return !(port > 0 && port <= 65535 && isValidGatewayPort(portNumber) && portNumber.length <= 5)
  }
  const isapplicationTypeNotValid = (): boolean => {
    return (
      (applicationType !== '' && (!isValidText(applicationType) || applicationType.length > MAX_LENGTH)) || false
    )
  }
  const isIpAddressNotValid = (): boolean => {
    return (!isValidIp(ipAddress) || ipAddress.length === 0)
  }
  const isProtocolNotValid = (): boolean => protocol === null
  const isTimezoneNotValid = (): boolean => timezone === null

  const shouldDisableNextButton = (): boolean => {
    return (
      isGatewayNameNotValid() ||
      isapplicationTypeNotValid() ||
      isIpAddressNotValid() ||
      isGatewayDescriptionNotValid() ||
      isTimezoneNotValid() ||
      isProtocolNotValid() ||
      (protocol?.label !== 'MODBUS-TCP/IP' ? isPortNumberNotValid() : false)
    )
  }
  const shouldDisableAddButton = (): boolean => {
    return (
      isStdError || isCustomError || isModbusError
    )
  }

  return (
    <div>
      <div role="presentation" data-testid="breadcrumbs" onClick={handleBreadCrumbsClick} className="AmiHeading">
        <ArrowBackIos className="assetmgmtli" data-testid="breadcrumb-arrow-back" aria-label="navArrow" sx={{ marginTop: '10px' }}
          onClick={() => {
            navigate(-1)
          }}
        />
        <Breadcrumbs aria-label='breadcrumb' sx={{ color: '#f0f0f0', fontSize: '12px', marginBottom: '14px', fontFamily: 'Honeywell Sans Web', marginTop: '12px' }}>
          <Link aria-label='navBreadcrumb1' className='assetmgmtli' data-testid="bc-link-1" underline='none' color='inherit' onClick={() => { navigate('/thermal-dashboard') }} >
            {DashboardStrings.HOME}
          </Link>
          <Link aria-label='navBreadcrumb2' className='assetmgmtli' data-testid="bc-link-2" underline='none' color='inherit' onClick={() => { navigate('/site-list') }} >
            {DashboardStrings.SiteManagement}
          </Link>
          <Link aria-label='navBreadcrumb3' className='assetmgmtli' data-testid="bc-link-3" underline='none' color='inherit' 
            onClick={() => { navigate(`/thermal-asset-list/${parentSiteId}`) }}>
            {DashboardStrings.AssetManagement}
          </Link>
          <Link aria-label="navBreadcrumb4" className='assetmgmtli' data-testid="bc-link-4" underline="none" color="inherit"
            onClick={() => {
              navigate(`/gateway-list/${parentAssetId}`, { state: { parentSiteId } })
            }}
          >
            {DashboardStrings.GatewayManagement}
          </Link>
          <Typography color="inherit" sx={{ fontSize: '12px', fontFamily: 'Honeywell Sans Web' }}>{DashboardStrings.CreateNewGateway}</Typography>
        </Breadcrumbs>
      </div>
      <div className="ArrowGatewayAdd">
        <div>
          <span data-testid="gatewayHistoryDetails" className="gatewayMgtGatewaylist" style={{ fontSize: '20px', fontWeight: '900', fontStyle: 'normal', lineHeight: '32px', }}>
            {AddGatewayStrings.AddGateway}
          </span>
        </div>
      </div>
      <div>
        <GatewayInformation
          assetModel={assetModel}
          setAssetModel={setAssetModel}
          assetType={assetType}
          protocolOptions={protocolOptions}
          protocol={protocol}
          setProtocol={setProtocol}
          timezoneOptions={timezoneOptions}
          timezone={timezone}
          setTimezone={setTimezone}
          setAssetType={setAssetType}
          gatewayType={props.gatewayType.gatewayType}
          gatewayName={gatewayName}
          setGatewayName={setGatewayName}
          gatewayNameErrorInit={gatewayNameErrorInit}
          setGatewayNameErrorInit={setGatewayNameErrorInit}
          gatewayDescription={gatewayDescription}
          setGatewayDescription={setGatewayDescription}
          gatewayDescriptionErrorInit={gatewayDescriptionErrorInit}
          setGatewayDescriptionErrorInit={setGatewayDescriptionErrorInit}
          portNumber={portNumber}
          setPortNumber={setPortNumber}
          portNumberErrorInit={portNumberErrorInit}
          setPortNumberErrorInit={setPortNumberErrorInit}
          applicationType={applicationType}
          setApplicationType={setApplicationType}
          applicationTypeErrorInit={applicationTypeErrorInit}
          setApplicationTypeErrorInit={setApplicationTypeErrorInit}
          location={location}
          setLocation={setLocation}
          locationErrorInit={locationErrorInit}
          setLocationErrorInit={setLocationErrorInit}
          ipAddress={ipAddress}
          setIpAddress={setIpAddress}
          ipAddressErrorInit={ipAddressErrorInit}
          setIpAddressErrorInit={setIpAddressErrorInit}
          previewImage={previewImage}
          setPreviewImage={setPreviewImage}
          gatewayImage={gatewayImage}
          setGatewayImage={setGatewayImage}
          gatewayId={gatewayId}
        />
      </div>
      <div style={{
        height: '80px', backgroundColor: '#272727', margin: '50px 0 10px 0', borderRadius: 10, display: 'flex',
        justifyContent: 'space-between', alignItems: 'center', padding: '0 1em'
      }}
      >
        <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
          {isGatewayDetailsEnabled
            ? (
              <>
                <Button className='AddGatewayCancelButton' data-testid="cancel-btn-click" onClick={() => { handeleCancelClick() }}>
                  {AddGatewayStrings.Cancel}
                </Button>
                <Button
                  className={`${shouldDisableNextButton() ? 'btn-disabled' : ''}`}
                  dataTestId="next-btn-click"
                  onClick={() => {
                    setShowConfirmation(true)
                  }}
                  disabled={shouldDisableNextButton()}
                >
                  {AddGatewayStrings.Create}
                </Button>
              </>
            )
            : (
              <>
                <Button dataTestId="back-btn" className='AddGatewayCancelButton' onClick={moveBackOneStep}>
                  {AddGatewayStrings.Back}
                </Button>
                <Button
                  className={
                    /* istanbul ignore next */
                    `${shouldDisableAddButton() ? 'btn-disabled' : ''}`
                  } dataTestId="add-gateway-btn"
                  onClick={() => { setShowConfirmation(true) }} disabled={shouldDisableAddButton()}
                >
                  {AddGatewayStrings.AddGateway}
                </Button>
              </>
            )}
        </div>
      </div>
      {props.assetCategories.isLoading && handleFetchCategoryWithFailure()}
      {showConfirmation &&
        <Modal buttonTypeNegative='hollow' title={AddGatewayStrings.AddGateway} LabelNegative={AddGatewayStrings.Cancel} LabelPositive={AddGatewayStrings.Confirm} onClickPositive={() => {
          setShowConfirmation(false), setShowCreatePopup(true), handleCreateGateway()
        }} onClose={() => { setShowConfirmation(false) }} onClickNegative={() => { setShowConfirmation(false) }}>
          <p style={{ paddingTop: '1.2em' }}>{AddGatewayStrings.GatewayAddConfirmation}</p>
        </Modal>
      }
      {showCreatePopup && handleCreateGatewayWithFailure()}
      {
        showImagePopup && handleImageWithFailure()
      }
    </div>
  )
}

interface DispatchToProps {
  getOperationPermissions: (sub: string) => void
  fetchAssetCategories: () => void
  fetchGatewayType: (categoryTypeId: string) => void
  fetchGatewayModel: (gatewayTypeId: string) => void
  createGateway: (createGatewayPostRequest: CreateGatewayPostRequest) => void
  imageUpload: (imageUploadPostRequest: ImageUploadPostRequest) => void
  getCustomDeviceDropdownMetadata: () => void
  fetchTimeZones: () => void
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  getOperationPermissions: (sub: string) => dispatch(getOperationPermissions(sub)),
  fetchAssetCategories: () => dispatch(fetchAssetCategories()),
  fetchGatewayType: (categoryTypeId: string) => dispatch(fetchGatewayType(categoryTypeId)),
  createGateway: (createGatewayPostRequest: CreateGatewayPostRequest) => dispatch(createGateway(createGatewayPostRequest)),
  imageUpload: (imageUploadPostRequest: ImageUploadPostRequest) => dispatch(imageUpload(imageUploadPostRequest)),
  getCustomDeviceDropdownMetadata: () => dispatch(getCustomDeviceDropdownMetadata()),
  fetchTimeZones: () => dispatch(fetchTimeZones())
}) as DispatchToProps

interface StateToProps {
  assetCategories: AssetCategoriesState
  gatewayType: GatewayTypeState
  createGatewayState: CreateGatewayState,
  imageUploadState: ImageUploadState,
  DeviceDropDownMetadata: DeviceDropDownMetadataState,
  TimezoneDropDownMetadata: TimezoneDataState
}

const mapStateToProps = (state: RootState): StateToProps => ({
  assetCategories: state.gatewayManagementAssetCategories,
  gatewayType: state.gatewayManagementGatewayType,
  createGatewayState: state.createGatewayState,
  imageUploadState: state.imageUploadStateGateway,
  DeviceDropDownMetadata: state.deviceDropDownMetadata,
  TimezoneDropDownMetadata: state.timezoneDropDownMetaData
})

const connector = connect(mapStateToProps, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(AddGatewayComponent)
